"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Size = void 0;
var Size;
(function (Size) {
    Size["SMALL"] = "S";
    Size["MEDIUM"] = "M";
    Size["LARGE"] = "L";
    Size["TINY"] = "XS";
})(Size = exports.Size || (exports.Size = {}));
